<template><div><h1 id="dokumente-stammtabelle" tabindex="-1"><a class="header-anchor" href="#dokumente-stammtabelle"><span>Dokumente, Stammtabelle</span></a></h1>
<p>Dokumente — Stammtabelle der Dokumenten im Document Output</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden die Dokumente auf Grund von Vorlagen erstellt. Nach Zuordnung der Vorlage (worin die Aufteilung des Dokumentes und die Platzierung der Text- und Bildbausteine definiert ist) wird den Text- und Bildbausteinen im Dokument ein Text oder ein Bild zugeordnet. Die Zuordnung kann auch abhängig von Attribut-Werten vorgenommen werden, so dass optional verschiedene Texte und Bilder im Dokument angezeigt werden können.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Document Output → Dokumente</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Name</dt>
<dd>
<p>Kurzbezeichnung des Dokumentes</p>
</dd>
<dt>Beschreibung</dt>
<dd>
<p>Beschreibungstext</p>
</dd>
<dt>Vorlage</dt>
<dd>
<p>Lookup auf die Tabelle <a class="link" href="ft.refdata.do-vorlagen.html" title="Vorlagen">Vorlagen</a> mit hinterlegten XSL-Stylesheets, Word-Dokumenten oder Word-Dokumentenvorlagen.</p>
</dd>
<dt>Typ</dt>
<dd>
<p>Art des Dokumentes: Knoten, PDF, HTML oder leer (Word-Dokument)<br>Im Editmodus lässt sich nur &quot;&quot; oder &quot;Knoten&quot; wählen. Typ &quot;Knoten&quot; erfasst einen Knoten, mit dem sich eine Baumstruktur anlegen lässt.</p>
</dd>
<dt>Übergeordnetes Element</dt>
<dd>
<p>Das Dokument/der Knoten wird, unterhalb dem ausgewählten Knoten, in einer Baumstruktur abgelegt.</p>
</dd>
<dt>Status</dt>
<dd>
<p>Default-Wert ist &quot;aktiv&quot;. Inaktive Dokumente werden in der Dokumentenansicht nicht angezeigt (Filter).</p>
</dd>
<dt>Text- und Bildbausteine</dt>
<dd>
<p>Text- und Bildbausteine der Dokumente. Sie werden nach der Erfassung eines Dokumentes automatisch zugeordnet. Mit jedem der Text- oder Bildbausteine können Texte oder Bilder verknüpft werden. Diese werden unter <a class="link" href="ft.refdata.do-text.html" title="Text- und Bildelemente">Text- und Bildelemente</a> vorerfasst. Zu den einzelnen Bausteinen können mehrere Texte/Bilder erfasst werden. Über die <a class="link" href="ft.refdata.do-attribute.html" title="Attribute">Attribute</a> wird gesteuert, zu welchen Attributen die entsprechenden Texte und Bilder angezeigt werden sollen.</p>
</dd>
<dd>
<p>Detail-Ansicht der zugeordneten Texte und Bilder.</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="vorschau" tabindex="-1"><a class="header-anchor" href="#vorschau"><span>Vorschau</span></a></h3>
<p>Erzeugt eine Vorschau für das entsprechende Dokument.</p>
<h3 id="attribute-separate-tabelle" tabindex="-1"><a class="header-anchor" href="#attribute-separate-tabelle"><span>Attribute (separate Tabelle)</span></a></h3>
<p>Ergänzt beliebige <RouteLink to="/referenz/refs/ft.refdata.do-attribute.html" title="Attribute">Attribute</RouteLink> als Spalten zu den Text- und Bildbausteinen.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.do-attribute.html" title="Attribute">Attribute</RouteLink>, <RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.do-text.html" title="Text- und Bildelemente">Text- und Bildbausteine</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.do-vorlagen.html" title="Vorlagen">Vorlagen</RouteLink>, Kundenspezifische Dokumentation</p>
</div></template>


